import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoSi: CultureInfo = {
  name: 'si',
  displayName: 'Sinhala',
  iso3LanguageCode: 'sin',
  iso2LanguageCode: 'si',
  ietfLanguageTag: 'si',
  parent: null
};
